var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horizontal-bar-chart',{staticStyle:{"width":"100%","height":"400px"},attrs:{"chartData":_vm.getChartData,"options":_vm.getOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }